import classNames from 'classnames'

import { commonIcons } from '@apps-common/config/icons'

interface IProps {
  autoClose?: number | false
  className?: string
  paused?: boolean
  onClose?: () => void
}

const CLOSE_TIMER_CIRCUMFERENCE = 94.25

export const ToastCloseTimerButton: React.FC<IProps> = ({ autoClose, className, paused, onClose }) => {
  const duration = typeof autoClose === 'number' && autoClose > 0 ? autoClose : undefined

  return (
    <button
      type='button'
      aria-label='Close toast'
      className={classNames('toast-close-timer-button', className)}
      onClick={(e) => {
        e.stopPropagation()
        onClose?.()
      }}
    >
      {duration && (
        <svg className='toast-close-timer-button__svg' viewBox='0 0 34 34' aria-hidden='true'>
          <circle className='toast-close-timer-button__track' cx='17' cy='17' r='15' />
          <circle
            className='toast-close-timer-button__progress'
            cx='17'
            cy='17'
            r='15'
            style={
              {
                '--toast-close-duration': `${duration}ms`,
                '--toast-close-circumference': CLOSE_TIMER_CIRCUMFERENCE,
                animationPlayState: paused ? 'paused' : 'running'
              } as React.CSSProperties
            }
          />
        </svg>
      )}
      <span className='toast-close-timer-button__inner'>
        <commonIcons.close />
      </span>
    </button>
  )
}
